import React from "react";
import SignEstimateContent from "../content/signEstimateContent";
import Layout from "../layout/Layout";

function SignEstimate() {
  return (
    <Layout>
      <SignEstimateContent />
    </Layout>
  );
}

export default SignEstimate;
